/******************************************************************************

Copyright (c) 2020-2021, Visual Elements AS

******************************************************************************/

// @format
/** Show a dimmer backdrop
   *
   *  Used to catch input when showing modals, context menus etc.
   *
   *  @example
   *  dimmer(function () {
   *       alert('You clicked the dimmer!');
   *  });
   *
   *  @param {function} fn - the function to call when the dimmer is clicked
   *  @param {bool} autohide - set to true to hide the dimmer when it's clicked
   *  @param {bool} transparent - set to true for the dimmer to be transparent
   *  @param {number} zIndex - the z index *offset*
   *  @return {function} - A function that can be called to hide the dimmer
   */

import { isFn } from "./highcharts-editor";
import {cr, ap, setStyle, on } from "./highed.dom";

export default function(fn, autohide, transparent, zIndex) {
  let dimmer = cr('div', 'highed-dimmer'),
    unbinder = false;

  ap(document.body, dimmer);

  setStyle(dimmer, {
    opacity: 0.4,
    'pointer-events': 'auto',
    'z-index': 9999 + (zIndex || 0)
  });

  if (transparent) {
    setStyle(dimmer, {
      opacity: 0
    });
  }

  function hide() {
    setStyle(dimmer, {
      opacity: 0,
      'pointer-events': 'none'
    });

    if (isFn(unbinder)) {
      unbinder();
      unbinder = false;
    }

    window.setTimeout(function() {
      if (dimmer.parentNode) {
        dimmer.parentNode.removeChild(dimmer);
      }
    }, 300);
  }

  unbinder = on(dimmer, 'click', function(e) {
    if (isFn(fn)) {
      fn();
    }

    if (autohide) {
      hide();
    }
  });

  return hide;
};